<template>
    <div class="container">
        <div class="topDiv_item"  @click="showPopup()">
              <span class="topDiv_item_span">{{HT}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
         <tab-list :tabList="tabBar" @tabClick="tabClick" :cur="activeTab"></tab-list>
         <div class="scroll">
             <scroll v-if="couponArr.length" :data="couponArr"
                :allLoaded="allLoaded"  @pulldown="loadData" @loadUp="loadup" >
                <div  v-for="(item,index) in couponArr" :key="index" >
                   <div class="list_box" >
                       <img @click="goDetail(item)"  v-if="item.status==0 &&item.templateType==1" class="list_box_bg" src="../../assets/images/img_ticket_center.png"/>
                       <img @click="goDetail(item)"  v-else-if="activeTab==0 && item.templateType!=1" class="list_box_bg" src="../../assets/images/img_ticket_fanjin.png"/>
                       <img v-else class="list_box_bg" src="../../assets/images/img_ticket_grayBG.png"  />
                       <div class="list_box_left" @click="goDetail(item)">
                           <div v-if='item.templateType==1' :class="['list_box_left_div1', item.status!=0 ? 'grayClass':'greenClass' ]">
                               <span class="list_box_left_span1">{{item.templateTypeName}}</span>
                           </div>
                           <div v-else :class="['list_box_left_div2', item.status!=0 ? 'grayClass':'yellowCloss' ]">
                               <span :class="['list_box_left_span2', item.status!=0 ? 'whiteClass':'blackClass' ]" >{{item.templateTypeName}}</span>
                           </div>
                           <div v-if="item.discountMode == '1'" class="list_box_left_body">
                                   <span :class="['list_box_left_body_span1', item.status!=0 ? 'grayTextClass':'redTextClass' ]" >￥</span>
                                   <span :class="['list_box_left_body_span2', item.status!=0 ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount}}</span>
                           </div>
                           <div v-else class="list_box_left_body">
                                   <span :class="['list_box_left_body_span2',  item.status!=0 ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount/10}}</span>
                                   <span  :class="['list_box_left_body_span3', item.status!=0 ? 'grayTextClass':'redTextClass' ]" >折</span>
                           </div>
                       </div>
                       <div class="list_box_right" @click="goDetail(item)" >
                            <span class="list_box_right_span1">{{item.activeSource== '0'?item.activeName:(item.name || item.templateName)}}</span>
                            <span class="list_box_right_span2">{{item.beginTime | date}}-{{item.endTime | date}}</span>
                            <span class="list_box_right_span3">{{item.templateDescr}}</span>

                       </div>
                       <div v-if="item.status==0 && item.link" class="useDiv" @click="toUse(item)">
                            <span class="useDiv_span">去使用</span>
                       </div>
                       <img class="usedImg" v-else-if="item.status==1 || item.status==3" src="../../assets/images/icon_ticket_used.png"/>
                       <img class="usedImg" v-else-if="item.status==2" src="../../assets/images/icon_ticket_expired.png"/>
                   </div>

                </div>
             </scroll>
             <no-message v-if="!couponArr.length && loaded"></no-message>
         </div>

        <common-footer class="footer_btnbg">
            <div class="footer_btn" @click="goVoucher">
                 <span class="footer_btn_span" >领券中心</span>
                 <div class="footer_btn_reddiv">
                     <span class="footer_btn_red_span">领更多好券</span>
                 </div>
            </div>
        </common-footer>

         <div class="popview" v-if="showPop">
          <div class="popviewBody">
              <div class="popviewItem" v-for="(item,index) in HTList" :key="index"  @click="selectVType(index)" >
                  <span :class="[index==HTListIndex? 'popviewItemSpan1' :'popviewItemSpan']">{{item.dictName}}</span>
              </div>
          </div>
          <div class="popviewFoot" @click="showPopup()"></div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import tabList from '../../components/tabbar';
import Scroll from '../../components/scroll';
import NoMessage from '../../components/nomessage';
import commonFooter from "../../components/commonFooter";
import {memberhttpgetMbBondListByUserId, getBondDict} from "../../utils/api";
export default {
  name: "myCoupon",
  components: {
      tabList,
      Scroll,
      commonFooter,
      NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      HT:"全部卡券",
      HTList:[{"dictName":'全部卡券'}],
      HTListIndex:0,
      type:'',
      showPop:false,
      tabBar:['未使用', '已使用', '已过期',],
      activeTab:0,
      pageNo:1,
      couponArr:[],
      loaded: false,
      allLoaded: false,
    }
  },
  filters: {
      date: function(data) {
        if (data) {
          return data.split('-').join('.')
        }
      }
  },
  created () {
    this.getBondDict();
  },
  activated(){
      this.pageNo = 1;
      this.getMbBondListByUserId();
  },
  methods: {
      getBondDict() {
        getBondDict({}).then(res => {
          if (res.res.code === 10000) {
                var list = res.body.dictList;
                var allList =[];
                var allItem ={"dictName":"全部卡券","dictValue":''};
                allList.push(allItem);
                this.HTList = [...allList, ...list];
          }
        });
      },
       getMbBondListByUserId(){
         var param = {
          "status": String(this.activeTab),
          "pageNo": this.pageNo,
          "pageSize": 10,
          "type": this.type,
          "payAmount": "",
          "memberCode":this.common.userInfo.memberCode, //head里面传
          "marketId": this.common.marketInfo.id,
        }
       memberhttpgetMbBondListByUserId(param).then(res => {
           // console.log(res)
            this.loaded =true;
            if (res.res.code === 10000) {

                var list = res.body.mbBondItemList;
                if (this.pageNo === 1) {
                    this.couponArr =  list ;
                } else {
                    this.couponArr = this.couponArr.concat(list )
                }
                if(!list ){
                    this.allLoaded =true
                } else if(list.length%10==0){
                    this.allLoaded =false
                }else{
                    this.allLoaded =true;
                }
            }
        });

     }  ,

    goVoucher(){
        var path ="/distributionVoucher";
        this.$router.push({
          path: path
        })
    },
    toUse(item){
          if(item.link){
              this.$router.push({
                path: item.link
            })
          }
      },

    goDetail(item){
        if(this.activeTab==0){
           // item.code,item.link
            var path ="/couponDetails/"+item.activeId+"?code="+item.code+"&id="+item.id;
            if(item.link){
                path =path+"&link="+encodeURIComponent(item.link)
            }
            if(item.templateId){
                path =path+"&templateId="+item.templateId
            }
            this.$router.push({
                path: path
            })
        }
    },
    tabClick (val) {
      this.activeTab = val;
      this.pageNo = 1;
      this.getMbBondListByUserId();
    },
    loadup () {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getMbBondListByUserId();
    },
    loadData () {
      this.pageNo = 1;
      this.getMbBondListByUserId();
    },
    showPopup(){
        this.showPop= !this.showPop;
        // if(this.showPopup){
        //      var mo=function(e){e.preventDefault();};
        //      document.body.style.overflow='hidden';
        //      document.addEventListener("touchmove",mo,false);//禁止页面滑动
        // }else{
        //      var mo=function(e){e.preventDefault();};
        //      document.body.style.overflow='hidden';
        //      document.addEventListener("touchmove",mo,false);//禁止页面滑动
        // }
    },
     selectVType(index){
        this. HTListIndex=index;
        this. HT=this.HTList[index].dictName;
        this.showPop=false;
        this.type=this.HTList[index].dictValue;
            //
        this.pageNo=1;
        this.getMbBondListByUserId();
    },

  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    height: 100vh;
    position: relative;
    background:rgba(255,255,255,1);
    .flex(column);
    .scroll {
        flex: 1;
        height: 500px;
        margin-bottom: 108px;
    }
}
.popview{
    position: absolute;
    left: 0;
    top: 88px;
    width: 100%;
    height: 93.4%;
    background:rgba(0,0,0,0.3);
    flex-direction: column;
    display: flex;
    z-index: 9999;
}
.popviewBody{
    width: 100%;
    height: 480px;
    background-color: white;
    flex-direction: column;
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;

}
.popviewItem{
    width: 100%;
    align-items: center;
    display: flex;
    margin-top: 28px;
    margin-bottom: 28px;
}
.popviewItemSpan{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.popviewItemSpan1{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:#1740DA;
    line-height:40px;
}
.popviewFoot{
     width: 100%;
     flex: 1;
    //  background-color: red;

}

.topDiv_item{
    height: 100px;
    width:100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
}
.topDiv_item_span{
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
}

.topDiv_item_icon{
    width: 24px;
    height: 24px;
    margin-left: 16px;
    display: flex;
}


.list_box{
    height: 200px;
    width: 94.6%;
    // background-color: aqua;
    margin-top: 20px;
    margin-left: 20px;
    position: relative;
    flex-direction: row;

    .list_box_bg{
        left: 0;
        top: 0;
        position: absolute;
        height: 200px;
        width: 100%;
        z-index: 1;
    }
    .list_box_left{
        left: 0;
        top:0;
        position: absolute;
        height: 200px;
        width: 25%;
        // background-color: antiquewhite;
        z-index: 100;
        flex-direction: column;
        .list_box_left_div1{
            display: flex;
            width:100px;
            height:40px;
          //  background:rgba(22,188,132,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span1{
                text-align: center;
                font-size:24px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:24px;
            }

        }
        .list_box_left_div2{
            display: flex;
            width:100px;
            height:40px;
           // background:rgba(246,196,0,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span2{
                text-align: center;
                font-size:24px;
                font-weight:500;
                line-height:24px;
            }

        }
          .list_box_left_body{
                width: 100%;
                display: flex;
                margin-top: 30px;
                justify-content: center;
                flex-direction: row;
                align-items: flex-start;
                .list_box_left_body_span1{
                    height:40px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:40px;
                }
                .list_box_left_body_span2{
                    height:60px;
                    font-size:56px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:60px;
                }
                .list_box_left_body_span3{
                    margin-top: 30px;
                    height:28px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:28px;
                }

            }

    }
    .list_box_right{
        right: 25%;
        top: 0;
        position: absolute;
        flex-direction: column;
        height: 200px;
        width: 50%;
        z-index: 100;
        .list_box_right_span1{
            margin-left: 20px;
            margin-top: 28px;
            display: flex;
            width: 90%;
            height:42px;
            font-size:30px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:42px;
        }
        .list_box_right_span2{
            margin-left: 20px;
            margin-top: 30px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;

        }
        .list_box_right_span3{
            margin-left: 20px;
            margin-top: 4px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;
        }
    }
    .grayClass{
        background: #DADADA;
    }
    .greenClass{
        background:rgba(22,188,132,1)
    }
    .yellowCloss{
        background:rgba(246,196,0,1);
    }
    .blackClass{
        color:#333333;
    }
    .whiteClass{
        color: #ffffff;
    }
    .grayTextClass{
        color: #999999;
    }
    .redTextClass{
        color:rgba(252,63,86,1);
    }

    .useDiv{
        right: 26px;
        top: 120px;
        position: absolute;
        width:128px;
        height:52px;
        display: flex;
        background:rgba(255,255,255,1);
        border-radius:4px;
        justify-content: center;
        justify-items: center;
        align-items: center;
        z-index: 101;
        .useDiv_span{
            height:32px;
            font-size:26px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:32px;
        }
    }
    .usedImg{
        position: absolute;
        z-index: 101;
        right: 26px;
        top: 40px;
        width: 120px;
        height: 120px;
    }


    //pop view


}

.footer_btnbg{
    box-shadow:0px -4px 16px 0px rgba(0,0,0,0.05);
}

.footer_btn {
  width: 100%;
  display: flex;
  height: 108px;
  border-radius: 4px;
  background: #fff;

  justify-content: center;
  align-items: center;
  position: relative;
  .footer_btn_span{
      color: 333333;
      font-size: 32px;
      line-height:44px;
      height: 44px;

  }
  .footer_btn_reddiv{
      position: absolute;
      display: flex;
      top: 12px;
      right: 150px;
      width:130px;
      height:38px;
      background:rgba(252,63,86,1);
      border-radius:18px 18px 18px 0px;
      justify-content: center;
      align-items: center;
      .footer_btn_red_span{
          height:32px;
          font-size:22px;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:32px;
      }
  }
}

</style>